<template>
    <div>
        <div v-if="options_loaded && passed_filter" class="stylesoption">
            <template v-if="filtered_option_list.length > 0 && filtered_option_list[0].value !== null">
                <div class="form-group" :class="[!valid_selection ? 'has-error' : '']" :data-designer-component-id="component_id">
                    <label :for="'question--' + component_id">{{ title }}</label>
                    <span class="styled-select">
                        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                        </select>
                        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                            <option>Loading Options...</option>
                        </select>
                    </span>
                </div>
            </template>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareCylinder from "../DesignerQuestionHardwareCylinder.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareCylinder
        ],
    }
</script>
